'use strict';

$(function () {
    // 调试
    var log_box = $('.j-debugger');
    // 选择元素
    var story_title = $('.js-title'),
        story_question = $('.js-question'),
        story_answer = $('.js-answer'),
        story_base_layer = $('.js-base-layer'),
        cover_layer = $('.js-cover-layer'),
        tickets_wrap = $('.scratch-tickets'),
        gift_box1 = $('.js-gift-box1'),
        summary = $('.js-summary'),
        close_btn1 = $('.js-box1-close'),
        close_btn2 = $('.js-box2-close'),
        goto_gift_box1 = $('.js-goto-gift-box1'),
        goto_gift_box2 = $('.js-goto-gift-box2'),
        gift_box2 = $('.js-gift-box2'),
        gift_url = $('.js-gift-url'),
        save_btn = $('.js-save'),
        learn_more = $('.js-learn-more');
    // url
    var cover_image_url = '../images/cover-layer.png',
        learn_more_url = ["https://www.yandex.ru/search/?text=",, "&clid=2279161"];

    // 定时器 - 2秒
    var wait_time = 1800;

    // 解决canvas模糊问题
    var SEED = 4;
    // 计时器 开始则计时，结束计时则返回时间（毫秒）统计
    var Timer = {
        start: function start() {
            Timer._start_time = new Date();
        },
        end: function end() {
            var t = Timer,
                ret;
            if (t._start_time) {
                var ret = new Date() - t._start_time;
                t._start_time = '';
            }
            return ret;
        },
        // 倒计时-默认1.5秒
        startCountDown: function(){
            var time = 1500;
            var start = new Date();
            var flag = false;
            // debugger
            if(!Timer.startCountDown.start){
                Timer.startCountDown.start = start;
                flag = true;
            }else if( (start - Timer.startCountDown.start) > time ){
                Timer.startCountDown.start = new Date();
                flag = true;
            }
            console.log('-------------bug-----------%s %s', flag, (start - Timer.startCountDown.start))
            return flag;
        }
    };
    window.t = Timer;
    // 埋点
    // 需求文档 http://redmine.meizu.com/issues/632835
    // 技术文档 https://wiki.meizu.com/index.php?title=WEB%E9%A1%B5%E9%9D%A2%E7%BB%9F%E8%AE%A1%E6%95%B0%E6%8D%AE%E5%9F%8B%E7%82%B9%E8%A7%84%E8%8C%83
    var BuryingPoint = {
        init: function init() {
            this.loadLibrary();
            this.initData();
            // 根据魅族手机内嵌浏览器测试，横屏是0，竖屏是90
            // 测试角度为0 90 270
            window.addEventListener("orientationchange", function () {
                if (screen.orientation.angle !== 0) {
                    BuryingPoint.reportData({ action: BuryingPoint.data.evt.action11 });
                    console.log("横屏模式用户数-多次-over");
                    // 统计页面时长
                    BuryingPoint.pageLength(BuryingPoint.data.newPage, 'G', Timer.end());
                } else {
                    // console.log('test G <- %s', BuryingPoint.data.oldPage)
                    BuryingPoint.pageLength('G', BuryingPoint.data.oldPage, Timer.end());
                    if (is_open_in_landscape) {
                        // 为何要延迟？
                        setTimeout(function () {
                            Application.init();
                        }, 50);
                        is_open_in_landscape = false;
                    }
                }
            });
        },
        // 加载统计库flow.js-直接放在html底部
        loadLibrary: function loadLibrary() {
            window.__mztj = {
                unload: true
            };
            // 保持，防止点击了解更多，再次还来找不到MeizuBH函数
            // BuryingPoint.loadLibrary.TJ = MeizuBH;
        },
        loadLibraryFixed: function loadLibraryFixed(opts) {
            var __mztj = {
                unload: true
            };
            (function () {
                var ga = document.createElement('script'),
                    s;
                ga.type = 'text/javascript';
                ga.src = 'https://tongji-res.meizu.com/resources/tongji/flow.js';
                s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ga, s);
            })();
            setTimeout(function () {
                MeizuBH(opts);
            }, 5 * 1000);
        },
        initData: function initData() {
            var activity_id = '20171124_01'; // 活动id
            var evt_map = {
                // 动作
                action1: 'first_page_impression', // 页面A曝光事件
                action2: 'scrape_answer', // 刮答案事件
                action3: 'scrape_answer_over', // 刮完答案事件
                action4: 'giftcard_impression', // 礼物贺卡曝光事件
                action5: 'giftcard_click', // 礼物贺卡点击事件
                action6: 'giftcard_close', // 礼物贺卡关闭事件
                action7: 'hdimage_impression', // 高清图片展示事件
                action8: 'hdimage_download_buttion_click', // 高清图片下载事件
                action9: 'hdimage_close', // 高清图片关闭事件
                action10: 'learnmore_button_click', // 了解更多按钮点击事件
                action11: 'landscape_mode', // 横屏模式用户数

                // 页面时长
                durationPageA: 'first_page_dwelltime',
                durationPageB: 'answer_page_dwelltime',
                durationPageC: 'giftcard_page_dwelltime',
                durationPageD: 'hdimage_page_dwelltime',
                durationPageE: 'learnmore_page_dwelltime',
                durationPageG: 'landscape_page_dwelltime'
            };
            Timer.start(); // 开始计时
            BuryingPoint.data = {
                evt: evt_map,
                id: activity_id,
                oldPage: 'A',
                newPage: 'A',
                baseOpts: {
                    action: '',
                    imei: (window.MzJavascriptInterface && window.MzJavascriptInterface.getIMEI()) ,
                    activity_id: '20171124_01'
                }
            };
        },
        // 统计页面时长
        pageLength: function pageLength(old_page, new_page, time) {
            var bp = BuryingPoint;
            Timer.start(); // 开始计时
            // console.log('old_page=%s new_page=%s time=%d', old_page, new_page, time);
            console.log('old_page=' + old_page + ' new_page=' + new_page + ' time=' + time);
            // 点击”了解更多“，停止计时，回到页面再次点击，因为开始时间清除，这时time为空
            time && BuryingPoint.reportData({ action: BuryingPoint.data.evt['durationPage' + old_page], dwelltime: time });

            // 切换页面
            bp.data.oldPage = old_page;
            bp.data.newPage = new_page;
            // console.log('test2 %s -> %s', bp.data.oldPage, bp.data.newPage);
        },
        // 上报数据
        reportData: function reportData(opts) {
            // 合并参数，如果imei=undefined，则不会传递imei参数
            opts = $.extend({}, BuryingPoint.data.baseOpts, opts);
            log_box.html([(typeof MeizuBH) + '  ' + (typeof  __mztj) + ' opt=' + JSON.stringify(opts)].join('<br>'));
            // 统计
            try {
                console.log((typeof MeizuBH === 'undefined' ? 'undefined' : _typeof(MeizuBH)) + '  ' + (typeof __mztj === 'undefined' ? 'undefined' : _typeof(__mztj)) + ' opt=' + JSON.stringify(opts));
                MeizuBH(opts);
            } catch (e) {
                log_box.html([log_box.html() , e.message, JSON.stringify(e)].join('<br>'));
                console.log(e.message);
            }
        }
    };

    // 应用
    var Application = {
        init: function init() {
            this.initData();
            this.initScratchTickets(this.pushGift.bind(null, wait_time));
            this.initLearnMore();
            this.initEvt();
            BuryingPoint.reportData({ action: BuryingPoint.data.evt.action1 });
            console.log('页面A曝光事件-只触发一次-over');
        },
        initData: function initData() {
            // 故事安排3天；默认为1
            var story_index = (location.href.match(/story=(\d)/) ? location.href.match(/story=(\d)/)[1] : 1) - 1;
            // 测试
            if(location.href.match(/debugger/)){
                log_box.show();
            }
            var story = [{
                title: 'Сколько детей родила самая многодетная в мире мать, крестьянка Васильева из России?',
                question: 'Ей принадлежит мировой рекорд.В период с 1725 по 1765 она рожала 27 раз и никогда дети не рождались по одному',
                answer: '69 детей',
                summary: '',
                keyword: 'Федор Васильев Книга Рекордов Гиннесса',
                giftUrl: '../images/story1-card.jpg',
                giftUrl2: '../images/С днем матери-1.jpg'
            }, {
                title: 'В каком возрасте матерью стала самая пожилая роженица, Мария из Испании?',
                question: 'Ради операции по искусственному оплодотворению, она солгала, что ей 55 лет, и родила в 2009 году близнецов.',
                answer: 'В 67 лет',
                summary: '',
                keyword: 'Мария дель Кармен Бусада Лара',
                giftUrl: '../images/story2-card.jpg',
                giftUrl2: '../images/С днем матери-2.jpg'
            }, {
                title: 'Какой рекорд по временной разница между родами зафиксирован у Элизабет из Англии?',
                question: 'Она родила первого ребенка, когда ей было 19 лет, а второго малыша она родила уже в преклонном возрасте.',
                answer: '41 год',
                summary: '',
                keyword: 'Элизабет Энн Баттл',
                giftUrl: '../images/story3-card.jpg',
                giftUrl2: '../images/С днем матери-3.jpg'
            }];
            Application.data = {
                story: story,
                index: story_index
            };
            story = story[story_index];
            // 修改为当天数据，例如关键字、名称、问题、答案
            learn_more_url[1] = story.keyword;
            story_title.text(story.title);
            story_question.text(story.question);
            story_answer.text(story.answer);
            summary.text(story.summary);
            gift_url.attr('src', story.giftUrl);
            save_btn.attr('href', story.giftUrl2);
        },
        // 初始化相关事件
        initEvt: function initEvt() {
            this.initGiftBox();
            // jQ如何实现？
            gift_url.on('load', function () {
                gift_url.data('success', 1);
            });
            this.zoom(true);
        },
        // 缩放文字动画
        zoom: function zoom(isBig) {
            var v = isBig ? '0.5rem' : '0.36rem',
                self = this;
            learn_more.animate({ 'fontSize': v }, 'slow', function () {
                self.zoom(!isBig);
            });
        },
        // 初始化刮刮乐 - 此方法仅依赖“选择元素”
        initScratchTickets: function initScratchTickets(callback) {
            // 刮刮乐刮了的百分比
            function getTransparentPercent(ctx, width, height) {
                var imgData = ctx.getImageData(0, 0, width, height),
                    pixles = imgData.data,
                    transPixs = [];
                for (var i = 0, j = pixles.length; i < j; i += 4) {
                    var a = pixles[i + 3];
                    if (a < 128) {
                        transPixs.push(i);
                    }
                }
                return (transPixs.length / (pixles.length / 4) * 100).toFixed(2);
            }

            var bodyStyle = document.body.style;
            var stepClear;
            var ctx = cover_layer[0].getContext('2d');
            window.ctx = ctx;
            // 文本不能被选择
            bodyStyle.mozUserSelect = 'none';
            bodyStyle.webkitUserSelect = 'none';
            // 优化 图片会闪烁
            story_answer.toggle();
            story_base_layer.toggle();
            var w,h,
                offsetX = cover_layer[0].parentElement.offsetLeft,
                offsetY = cover_layer[0].parentElement.offsetTop,
                mousedown = false;
            function layerImage() {
                var img = new Image();

                img.src = cover_image_url;
                // 优化 图片会闪烁
                img.onload = function () {
                    // console.log('------------222 %s %s', cover_layer.css('width'),cover_layer.css('height'));
                    // console.log('------------221 %s %s', cover_layer.attr('width'),cover_layer.attr('height'));
                    cover_layer.attr(
                        {width: parseFloat(cover_layer.css('width'))*SEED, height:
                        parseFloat(cover_layer.css('height'))*SEED}
                        );
                    // console.log('------------223 %s %s', cover_layer.css('width'),cover_layer.css('height'));
                    // console.log('------------224 %s %s', cover_layer.attr('width'),cover_layer.attr('height'));
                    // 设置canvas中image的宽高
                    ctx.drawImage(img, 0, 0, cover_layer.attr('width'),cover_layer.attr('height'));
                    w = cover_layer.attr('width');
                    h = cover_layer.attr('height');


                    // 设置canvas中image的宽高
                    ctx.drawImage(img, 0, 0, w, h);
                    // 设置文字样式，垂直居中
                    ctx.font = (14*SEED) + 'px bolder roboto';
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    ctx.fillStyle = "#f8504e";
                    ctx.fillText("Проведите, чтобы узнать ответ", w / 2, h / 2);
                    story_answer.toggle();
                    story_base_layer.toggle();
                };
            }

            function eventDown(e) {
                mousedown = true;
                e.preventDefault && e.preventDefault();
            }

            function eventUp(e) {
                mousedown = false;
                e.preventDefault && e.preventDefault();
            }
            // 扩展clearArc
            function clearArc(x, y, radius) {
                //圆心(x,y)，半径radius  
                var calcWidth = radius - stepClear;
                var calcHeight = Math.sqrt(radius * radius - calcWidth * calcWidth);
                var posX = x - calcWidth;
                var posY = y - calcHeight;
                var widthX = 2 * calcWidth;
                var heightY = 2 * calcHeight;

                if (stepClear <= radius) {
                    ctx.clearRect(posX, posY, widthX, heightY);
                    stepClear += 1;
                    clearArc(x, y, radius);
                }
            }

            function eventMove(e) {
                e.preventDefault();
                if (mousedown) {
                    if (e.changedTouches) {
                        e = e.changedTouches[e.changedTouches.length - 1];
                    }
                    var x = (e.clientX + document.body.scrollLeft || e.pageX) - offsetX || 0,
                        y = (e.clientY + document.body.scrollTop || e.pageY) - offsetY || 0;
                    var x2 = e.pageX - offsetX,
                        y2 = e.pageY - offsetY;
                    x *= SEED;
                    y *= SEED;    
                    ctx.beginPath();
                    stepClear = 1; //别忘记这一步
                    // console.log('x=%d y=%d x2=%d y2=%d w=%d h=%d', x, y, x2, y2, w, h);
                    clearArc(x, y, 20*SEED);
                    if (BuryingPoint.data.evt.action2) {
                        BuryingPoint.reportData({ action: BuryingPoint.data.evt.action2 });
                        console.log('刮答案事件-一个页面应该也值触发一次 over');
                        BuryingPoint.data.evt.action2 = '';
                    }
                    var per = getTransparentPercent(ctx, w, h);
                    if (per > 25) {
                        // console.log(per);
                        ctx.clearRect(0, 0, w, h);

                        if (BuryingPoint.data.evt.action3) {
                            BuryingPoint.reportData({ action: BuryingPoint.data.evt.action3 });
                            console.log('刮完答案事件-一个页面应该只触发一次 over');
                            BuryingPoint.data.evt.action3 = '';
                            // 统计页面时长
                            BuryingPoint.pageLength(BuryingPoint.data.newPage, 'B', Timer.end());
                        }
                        (per < 100) && callback();
                    }
                }
            }
            layerImage();
            // cover_layer.attr('width', cover_layer.css('width'));
            // cover_layer.attr('height', cover_layer.css('height'));
            cover_layer[0].addEventListener('touchstart', eventDown);
            cover_layer[0].addEventListener('touchend', eventUp);
            cover_layer[0].addEventListener('touchmove', eventMove);
            cover_layer[0].addEventListener('mousedown', eventDown);
            cover_layer[0].addEventListener('mouseup', eventUp);
            cover_layer[0].addEventListener('mousemove', eventMove);
        },
        // 了解更多
        initLearnMore: function initLearnMore() {
            learn_more.on('click', function () {
                BuryingPoint.reportData({ action: BuryingPoint.data.evt.action10 });
                console.log('了解更多按钮点击事件-多次-over');

                // 统计页面时长
                BuryingPoint.pageLength(BuryingPoint.data.newPage, '', Timer.end());
                Timer._start_time = NaN;
                window.open(learn_more_url.join(''));
                // window.location.href=learn_more_url.join('');
            });
        },
        // 有两个礼物盒
        // 思考：显示隐藏，反复，是否可以根据数据来更改？
        initGiftBox: function initGiftBox() {
            close_btn1.on('click', function () {
                // 进入页面E
                // 进入页面E
                gift_box1.css({ 'left': 'auto', 'top': 'auto', 'bottom': 0, 'right': 0 });
                gift_box1.hide('slow');
                // 显示到右下角
                goto_gift_box2.show();
                BuryingPoint.reportData({ action: BuryingPoint.data.evt.action6 });
                console.log('礼物贺卡关闭事件-一次-over');
                // 统计页面时长
                BuryingPoint.pageLength(BuryingPoint.data.newPage, 'E', Timer.end());
            });
            close_btn2.on('click', function () {
                // 进入页面E
                gift_box2.css({ 'left': 'auto', 'top': 'auto', 'bottom': 0, 'right': 0 });
                gift_box2.hide('slow');
                // 显示到右下角
                goto_gift_box2.show();
                BuryingPoint.reportData({ action: BuryingPoint.data.evt.action9 });
                console.log('高清图片关闭事件-多次-over');
                // 统计页面时长
                BuryingPoint.pageLength(BuryingPoint.data.newPage, 'E', Timer.end());
            });
            goto_gift_box2.on('click', function () {
                // 进入页面D
                var t = $(this);
                gift_box1.hide();
                // alert(2); 
                console.log('test001 %s %s', t.attr('data-flag'));
                if (t.attr('data-flag') === 'big') {
                    gift_box2.fadeIn('slow'); // 动画
                } else {
                    // gift_box2.css({ 'left': 'auto', 'top': 'auto', 'bottom': 0, 'right': 0 });
                    gift_box2.fadeIn('slow');
                }

                BuryingPoint.reportData({ action: BuryingPoint.data.evt.action7, download_situation: gift_url.data('success') ? 'success' : 'fail' });
                console.log('高清图片展示事件-' + (gift_url.data('success') ? 'success' : 'fail') + '多次-over');
                BuryingPoint.reportData({ action: BuryingPoint.data.evt.action5, size: $(this).data('flag') });
                console.log('礼物贺卡点击事件-' + $(this).data('flag') + '-多次-over');
                // goto_gift_box2.hide();
                // 统计页面时长
                BuryingPoint.pageLength(BuryingPoint.data.newPage, 'D', Timer.end());
            });
            save_btn.on('click', function (e) {
                // 计时开始
                if(!Timer.startCountDown()){
                    e.preventDefault();
                    return;
                }
                BuryingPoint.reportData({ action: BuryingPoint.data.evt.action8 });
                console.log('高清图片下载事件-多次-over');
            });
        },
        // 推送礼物
        pushGift: function pushGift(time) {
            setTimeout(function () {
                // 显示”礼物盒子1“和”了解更多“
                gift_box1.fadeIn('slow');
                learn_more.fadeIn('slow');

                if (BuryingPoint.data.evt.action4) {
                    BuryingPoint.reportData({ action: BuryingPoint.data.evt.action4 });
                    console.log('礼物贺卡曝光事件-一个页面应该只触发一次 over');
                    BuryingPoint.data.evt.action4 = '';
                    // 统计页面时长
                    BuryingPoint.pageLength(BuryingPoint.data.newPage, 'C', Timer.end());
                }
            }, time);
        }
    };

    BuryingPoint.init();
    // 用户以横屏方式打开页面bug修复
    var is_open_in_landscape = screen.orientation.angle !== 0;
    if (!is_open_in_landscape) {
        Application.init();
    }
    // console.log(window.MzJavascriptInterface + "  " + window.MzJavascriptInterface.getIMEI() + ' ' + window.MzJavascriptInterface.isMzBrowser())
});